import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.territoryAssignments.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.territoryAssignments.actionsLoading;
export const getItems = (state:RootState) => state.territoryAssignments.items;
export const getItemsSelect = (state:RootState) => state.territoryAssignments.dropDownItems;
export const getItemsCount = (state:RootState) => state.territoryAssignments.itemsCount;
export const getItemForEdit = (state:RootState) => state.territoryAssignments.itemForEdit;
export const getError = (state:RootState) => state.territoryAssignments.error;
export const getErrorAction = (state:RootState) => state.territoryAssignments.errorAction;
export const validationErrors = (state:RootState) => state.territoryAssignments.validationErrors;

export const getTerritoryAssignmentTerritories = (state:RootState) => state.territoryAssignments[constants.TERRITORY_ASSIGNMENT_TERRITORIES];
export const getTerritoryAssignmentTerritoriesLoading = (state:RootState) => state.territoryAssignments[constants.TERRITORY_ASSIGNMENT_TERRITORIES_LOADING];

export const getTerritoryAssignmentUsers = (state:RootState) => state.territoryAssignments[constants.TERRITORY_ASSIGNMENT_USERS];
export const getTerritoryAssignmentUsersLoading = (state:RootState) => state.territoryAssignments[constants.TERRITORY_ASSIGNMENT_USERS_LOADING];
